module.exports = __webpack_public_path__ + "static/media/question.57c1c3e8.png";